import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { AuthApiService, ForgotPasswordDTO } from 'features/auth';

const { ForgotPassword } = AuthApiService();

type ForgotPasswordPayload = ForgotPasswordDTO & { persistSession: boolean };

export const useForgotPassword = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: ForgotPasswordPayload) => {
      const { Email, IsAdmin, UserType } = payload;

      return ForgotPassword({ Email, IsAdmin, UserType });
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data: any) => {
        message.success(data?.rm);
      },
    },
  );
};
